import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  scheduleSidebarTitle: {
    id: 'course-authoring.schedule.sidebar.about.title',
    defaultMessage: 'How are these settings used?',
  },
  scheduleSidebarAbout: {
    id: 'course-authoring.schedule.sidebar.about.text',
    defaultMessage: 'Your course\'s schedule determines when students can enroll in and begin a course. Other information from this page appears on the About page for your course. This information includes the course overview, course image, introduction video, and estimated time requirements. Students use About pages to choose new courses to take.',
  },
});

export default messages;
